import angular from "angular"

export const vsName = 'SlotTrak.UserProfile'

import { vsServiceName as userProfileServiceName, UserProfileProvider } from './UserProfileProvider'

export function initializeUserProfileModule(serverProfile) {
  angular
    .module(vsName, [])
    .provider(userProfileServiceName, new UserProfileProvider(serverProfile))
}

